export default "__VITE_ASSET__5GKlWVly__"